import { render, staticRenderFns } from "./LegalMentionDevice.vue?vue&type=template&id=24d8d377&"
import script from "./LegalMentionDevice.vue?vue&type=script&lang=js&"
export * from "./LegalMentionDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d8d377')) {
      api.createRecord('24d8d377', component.options)
    } else {
      api.reload('24d8d377', component.options)
    }
    module.hot.accept("./LegalMentionDevice.vue?vue&type=template&id=24d8d377&", function () {
      api.rerender('24d8d377', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/LegalMentionDevice.vue"
export default component.exports